import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { AdminDashboardInterface } from '@edtech-ui/core/models/dashboard/admin-dashboard-data';
import { AdminService } from '@edtech-ui/core/services/admin-dashboard/admin.service';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, finalize, of, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-dashboard',
	standalone: true,
	imports: [CommonModule, MatProgressSpinnerModule],
	templateUrl: './dashboard.component.html',
	styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit, OnDestroy {

	isDropdownOpen = false;
	isLoading: boolean = true;
	_adminCard: AdminDashboardInterface[] = [];
	subscription = new Subscription();

	constructor(
		private _adminService: AdminService,
		private _toastr: ToastrService,
		private _authService: AuthServiceService,
		private router: Router,
		private dialog: MatDialog 


	) { }

	ngOnInit(): void {
		this.getAdminDashboard();
	}

	getAdminDashboard(): void {
		this.isLoading = true;
		this.subscription.add(
			this._adminService.getAdminDashboard().pipe(
				tap(response => {
					if (response.Data && response.Success) {
						this.isLoading = false;
						const _adminInfo = response.Data;
						this._adminCard = [
							{
								adminCount: _adminInfo.total_users,
								adminTitle: 'TOTAL USERS',
								icon: 'bi bi-people',
								cssClass: 'icon-light'
							},
							{
								adminCount: _adminInfo.total_teachers,
								adminTitle: 'TOTAL TEACHERS',
								icon: 'bi bi-person-gear',
								cssClass: 'icon-light'
							},
							{
								adminCount: _adminInfo.total_students,
								adminTitle: 'TOTAL STUDENTS',
								icon: 'bi bi-mortarboard',
								cssClass: 'icon-light'
							},
							{
								adminCount: _adminInfo.total_classrooms,
								adminTitle: 'TOTAL CLASSROOM',
								icon: 'bi bi-building',
								cssClass: 'icon-light'
							},
							{
								adminCount: _adminInfo.total_courses,
								adminTitle: 'TOTAL COURSES',
								icon: 'bi bi-journal-bookmark',
								cssClass: 'icon-light'
							},
							{
								adminCount: _adminInfo.total_quizzes,
								adminTitle: 'TOTAL QUIZZES',
								icon: 'bi bi-clipboard-check',
								cssClass: 'icon-light'
							}
						];
					} else {
						this._toastr.error(response.Message);
					}
				}),
				catchError(() => {
					this.isLoading = false;
					this._toastr.error('Something went wrong while fetching the information');
					return of(null);
				})).subscribe()
		);
	}

	toggleDropdown() {
		this.isDropdownOpen = !this.isDropdownOpen;
	}

	logout() {
		this._authService.logout(this.router).subscribe({
			next: (response) => {
				if (response.Success) {
					this._toastr.success(response.Message);
				} else {
					this._toastr.error(response.Message);
				}
			},
			error: () => {
				this._toastr.error('An error occurred during logout');
			}
		});
		this.dialog.closeAll();
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

}